import React, { useEffect, useState } from "react";

import { Alert, Button, Modal, Table } from "react-bootstrap";

import { useQuery } from "@tanstack/react-query";

import { ServiceOrderType } from "../../../../_constants/serviceOrder.ts";
import {
  convertKeysToCamelCase,
  getDateFromIso,
} from "../../../../_helpers/stringHelper";
import { pagination } from "../../../../_helpers/tableHelper";
import eye from "../../../../assets/svg/eye.svg";
import { ButtonFile } from "../../../../common/components/ButtonFile.tsx";
import Loader from "../../../../common/components/Loader";
import PaginationComponent from "../../../../common/components/PaginationComponent";
import ServiceTypeComponent from "../../../../common/components/ServiceTypeComponent.tsx";
import { IFile, IService } from "../../../serviceOrdering/reducers";
import { IResponseServices } from "../../reducers";
import { getDwellingServicesInventory } from "../../services";

export interface DwellingInventoriesModalProps {
  dwellingId: string;
}

const DwellingInventoriesModal: React.FC<DwellingInventoriesModalProps> = ({
  dwellingId,
}) => {
  const [page, setPage] = useState(1);
  const [showInventoryModal, setShowInventoryModal] = useState<boolean>(false);
  const { isLoading, error, data, refetch } = useQuery<
    IResponseServices,
    Error
  >(
    ["inventories", { page, dwellingId }],
    () =>
      getDwellingServicesInventory(page, dwellingId, [
        ServiceOrderType.INCOMING_INVENTORY,
        ServiceOrderType.OUTGOING_INVENTORY,
      ]),
    { refetchOnWindowFocus: false, enabled: showInventoryModal },
  );

  useEffect(() => {
    if (showInventoryModal) {
      refetch();
    }
  }, [showInventoryModal]);

  return (
    <>
      <Button
        className="btn dwelling_property-button_edit ms-2"
        variant="light"
        onClick={() => setShowInventoryModal(true)}
      >
        <img src={eye} alt="eye" />
      </Button>

      <Modal
        show={showInventoryModal}
        onHide={() => setShowInventoryModal(false)}
        centered={true}
      >
        <Modal.Header closeButton>
          <Modal.Title className="propertySheetDetailsPartTitle">
            Liste des états des lieux
          </Modal.Title>
        </Modal.Header>
        {isLoading ? (
          <Modal.Body>
            <Loader />
          </Modal.Body>
        ) : (
          <>
            {error && (
              <Modal.Body>
                <Alert variant="danger">
                  Erreur chargement des données : {error}
                </Alert>
              </Modal.Body>
            )}
            {!isLoading &&
            !error &&
            data?.services &&
            data.services.length > 0 ? (
              <>
                <Modal.Body>
                  <Table>
                    <tbody>
                      {convertKeysToCamelCase(data.services).map(
                        (inventory: IService, index: number) => (
                          <tr key={index}>
                            <td className="text-center">
                              <ServiceTypeComponent
                                type={inventory.type as keyof object}
                              />
                            </td>
                            <td className="text-center dark-purple-text">
                              {getDateFromIso(
                                inventory?.appointment?.startDate,
                              )}
                            </td>
                            <td className="text-center dark-purple-text">
                              <ul>
                                {inventory.report?.files?.map(
                                  (file: IFile, index: number) => (
                                    <ButtonFile
                                      key={index}
                                      path={file.path}
                                      label={file.type.label}
                                    />
                                  ),
                                )}
                              </ul>
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </Table>
                </Modal.Body>
                <Modal.Footer className="d-block mb-2">
                  <div className="navigationButtonWrapper">
                    <PaginationComponent
                      pages={pagination(data.count)}
                      activePage={page}
                      setActivePage={() => setPage((page) => page + 1)}
                    />
                  </div>
                </Modal.Footer>
              </>
            ) : (
              <Modal.Body>
                <Alert variant="warning">Aucun État des lieux disponible</Alert>
              </Modal.Body>
            )}
          </>
        )}
      </Modal>
    </>
  );
};
export default DwellingInventoriesModal;
